<template>
  <v-select
    v-bind="$attrs"
    :outlined="outlined"
    @input="updateFieldValue(name, $event)"
    @change="$emit('changed', $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
  ></v-select>
</template>
<script>
import baseInput from "./baseInput";

export default {
  props: {
    outlined: {
      default: true,
      type: Boolean,
    },
  },
  mixins: [baseInput],
};
</script>
